import { createGtm } from '@gtm-support/vue-gtm'

import {
  defineNuxtPlugin, useRuntimeConfig
} from '#imports'

// Google Tag Manager — loaded lazily so its ~350 KB script and main-thread cost
// don't compete with the hero's first paint. Installed on the first user
// interaction, with an idle fallback, so tracking still starts within moments of
// load while the critical rendering path stays clear.
export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()

  const install = () => {
    nuxtApp.vueApp.use(createGtm({
      id: config.public.GTM_ID,
      defer: true,
      compatibility: false,
      enabled: true,
      source: 'https://gtmss.venetacucine.com/gtm.js',
      debug: config.public.DEV,
      loadScript: true,
      trackOnNextTick: false
    }))
  }

  // GTM is a client-only concern; nothing to inject during SSR.
  if (import.meta.server) { return }

  let done = false
  const events = [ 'pointerdown', 'keydown', 'touchstart', 'scroll', 'mousemove' ]
  function start () {
    if (done) { return }
    done = true
    events.forEach(e => window.removeEventListener(e, start))
    install()
  }

  events.forEach(e => window.addEventListener(e, start, { once: true, passive: true }))
  // Idle fallback, but only after `load` so GTM never lands inside the critical
  // first-paint window (loading it mid-load just moves its cost onto LCP/TBT).
  const ric = window.requestIdleCallback || (cb => setTimeout(cb, 1))
  const armIdle = () => ric(start, { timeout: 4000 })
  if (document.readyState === 'complete') { armIdle() } else { window.addEventListener('load', armIdle, { once: true }) }
})
